import script from "./AddressVerificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressVerificationModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddressVerificationModal.vue?vue&type=style&index=0&id=261c7781&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-261c7781"]])

export default __exports__